import { api } from '@/shared/lib/api'

import type { NetworkingDeclaration, NetworkingUpdatePayload } from './types'

const declarationPath = (digitalProductId: string | number) =>
  `/user/digital_products/${digitalProductId}/networking_profile`

/**
 * Declaração de networking da participação do usuário autenticado.
 *
 * Recurso singular: não há `id` no path, então não existe superfície para ler ou
 * escrever o perfil de outra pessoa.
 */
export const fetchNetworkingDeclaration = async (
  digitalProductId: string | number
): Promise<NetworkingDeclaration> => {
  const response = await api.get(declarationPath(digitalProductId))

  return response.data.record
}

export const updateNetworkingDeclaration = async (
  digitalProductId: string | number,
  payload: NetworkingUpdatePayload
): Promise<NetworkingDeclaration> => {
  const response = await api.patch(declarationPath(digitalProductId), payload)

  return response.data.record
}
